import { Box, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { PayBaseModal } from './PayBaseModal';
import { ButtonV2 } from '../ui/PayButton';
import { CheckCircle } from '../ui/CheckCircle';
import { useTranslation } from 'react-i18next';

const PREFIX = 'PayItemsAddedModal';

const classes = {
    root: `${PREFIX}root`,
    typography: `${PREFIX}typography`,
    img: `${PREFIX}img`,
    successDialogContent: `${PREFIX}successDialogContent`
};

const StyledBox = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: theme.spacing(1, 2, 1.5, 2),
    [`&.${classes.root}`]: {
        zIndex: 99999
    },

    [`& .${classes.typography}`]: {
        fontWeight: 700
    },

    [`& .${classes.img}`]: {
        margin: theme.spacing(1, 0, 3, 0)
    },

    [`& .${classes.successDialogContent}`]: {
        marginBottom: theme.spacing(3)
    }
}));

interface PayItemsAddedModalProps {
    open: boolean;
    onCancel: () => void;
}

export const PayItemsAddedModal: React.FC<React.PropsWithChildren<PayItemsAddedModalProps>> = ({
    open,
    onCancel
}) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <PayBaseModal open={open} className={classes.root} onClose={onCancel}>
            <StyledBox>
                <CheckCircle className={classes.img} color={theme.palette.primary.main} />
                <Typography className={classes.typography} gutterBottom align="center" variant="h6">
                    {t('DIALOG_MPO_SUCCESS_TITLE')}
                </Typography>
                <Typography className={classes.successDialogContent} gutterBottom align="center">
                    {t('DIALOG_MPO_SUCCESS_BODY')}
                </Typography>
                <ButtonV2 fullWidth variant="contained" color="primary" onClick={onCancel}>
                    {t('DIALOG_MPO_SUCCESS_OK')}
                </ButtonV2>
            </StyledBox>
        </PayBaseModal>
    );
};
